import { TrackerEvent } from '../../tracker-event';
import {
  getPayloadAndEventNameForFormatView,
  getPayloadAndEventNameForCategoryView,
  getPayloadAndEventNameForCourseView,
  getPayloadAndEventNameForEnrollmentView,
  getPayloadAndEventNameForTransactionOrder,
  getPayloadAndEventNameForTransactionPayment,
} from '../support';

export const events = ({ tracker, condition }) => {
  const amplitude = tracker;
  const { userId, customerId } = condition;

  return {
    [TrackerEvent.PAGE_VIEW](data) {
      const eventName = TrackerEvent.PAGE_VIEW;
      amplitude.getInstance().logEvent(eventName, { customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.USER_SIGNUP]() {
      const eventName = 'VIEW_SIGNUP_PAGE';
      amplitude.getInstance().logEvent(eventName, { customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.USER_LOGIN]() {
      const eventName = 'VIEW_LOGIN_PAGE';
      amplitude.getInstance().logEvent(eventName, { customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.FORMAT_VIEW](format) {
      const { payload, eventName } = getPayloadAndEventNameForFormatView(format);
      amplitude.getInstance().logEvent(eventName, { ...payload, customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.CATEGORY_VIEW](category) {
      const { payload, eventName } = getPayloadAndEventNameForCategoryView(category);
      amplitude.getInstance().logEvent(eventName, { ...payload, customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.COURSE_VIEW](course) {
      const { payload, eventName } = getPayloadAndEventNameForCourseView(course);
      amplitude.getInstance().logEvent(eventName, { ...payload, customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.ENROLLMENT_VIEW](data) {
      const { payload, eventName } = getPayloadAndEventNameForEnrollmentView(data);
      amplitude.getInstance().logEvent(eventName, { ...payload, customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.ENROLLMENT_PENDING](data) {
      amplitude.setUserProperties();
    },
    [TrackerEvent.TRANSACTION_ORDER](data) {
      const { payload, eventName } = getPayloadAndEventNameForTransactionOrder(data);
      amplitude.getInstance().logEvent(eventName, { ...payload, customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.TRANSACTION_PAYMENT](data) {
      const { payload, eventName } = getPayloadAndEventNameForTransactionPayment(data);
      amplitude.identify(new amplitude.Identify().add('TOTAL_SPENT', payload.revenue));
      amplitude.identify(new amplitude.Identify().add('TOTAL_ORDERS', 1));
      amplitude.identify(new amplitude.Identify().set('LAST_PURCHASED_DATE', new Date()));
      amplitude.getInstance().logEvent(eventName, { ...payload, customer_id: customerId, user_id: userId });
    },
    [TrackerEvent.COMMON](data) {
      const { eventName, payload } = data;
      amplitude.getInstance().logEvent(eventName, { ...payload, customer_id: customerId, user_id: userId });
    },
  };
};
